export default __webpack_public_path__ + "static/media/ic_search.2a4148be.svg";